module.exports = __webpack_public_path__ + "img/person.92ceeafb.svg";